module.exports = __webpack_public_path__ + "34f815f73b055bedeb3d46af9fbbbd70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-cat-dogeza.png
// module id = 2055
// module chunks = 4